import Vue from 'vue'
import xss from 'xss'
import moment from 'moment'
import anchorme from 'anchorme'
import Util from '@/util'

import store from './store'

Vue.filter('capitalize', (value) => {
  if (!value) return ''
  value = value.toString()
  const arr = value.split(' ')
  const capitalizedArray = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalizedArray.push(capitalized)
  })
  return capitalizedArray.join(' ')
})

Vue.filter('truncate', (value, limit) => {
  return value.substring(0, limit)
})

Vue.filter('tailing', (value, tail) => {
  return value + tail
})

Vue.filter('time', (value, is24HrFormat = false) => {
  if (!value) return null

  const date = new Date(Date.parse(value))
  let hours = date.getHours()
  const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
  if (!is24HrFormat) {
    const time = hours > 12 ? 'AM' : 'PM'
    hours = hours % 12 || 12
    return `${hours}:${min} ${time}`
  }
  return `${hours}:${min}`
})

Vue.filter('date', (value, fullDate = false) => {
  value = String(value)
  const date = value.slice(8, 10).trim()
  const month = value.slice(4, 7).trim()
  const year = value.slice(11, 15)

  if (!fullDate) return `${date} ${month}`
  return `${date} ${month} ${year}`
})

Vue.filter('dateTime', (value) => {
  return moment(new Date(value)).format('DD-MM-YYYY HH:mm')
})

Vue.filter('csv', (value) => {
  return value.join(', ')
})

Vue.filter('filter_tags', (value) => {
  return value.replace(/<\/?[^>]+(>|$)/g, '')
})

Vue.filter('k_formatter', (num) => {
  return num > 999 ? `${(num / 1000).toFixed(1)}k` : num
})

Vue.filter('timeMinus', (seconds) => {
  if (seconds < 60) {
    return `${seconds} seconds`
  }
  const mm = parseInt(seconds / 60, 10)
  let ss = seconds - mm * 60
  ss = ss.toFixed(2)
  // If you were building a timestamp instead of a duration,
  // you would uncomment the following line to get 12-hour (not 24) time
  // if (hh > 12) {hh = hh % 12;}
  // These lines ensure you have two-digits

  // This formats your string to HH:MM:SS
  let textMin = ' minute '
  if (mm > 1) {
    textMin = ' minutes '
  }
  return `${mm + textMin + ss} seconds`
})

Vue.filter('countEnglish', (i) => {
  const j = i % 10
  const k = i % 100

  if (j === 1 && k !== 11) return `${i}st`
  if (j === 2 && k !== 12) return `${i}nd`
  if (j === 3 && k !== 13) return `${i}rd`

  return `${i}th`
})

Vue.filter('sanitize', (text, isAllowedUnformattingTags) => {
  if (!text) return text

  const options = {
    whiteList: {
      i: [],
      u: [],
      b: [],
      em: [],
      br: [],
      ul: [],
      ol: [],
      li: [],
      h1: [],
      h2: [],
      h3: [],
      h4: [],
      sup: [],
      sub: [],
      strong: [],
    },
  }

  if (isAllowedUnformattingTags) {
    options.whiteList = {
      ...options.whiteList,
      a: ['href'],
      source: ['src', 'type'],
      iframe: ['src', 'width', 'height', 'frameborder'],
      video: ['width', 'height', 'controls', 'autoplay'],
      audio: ['width', 'height', 'controls', 'autoplay'],
    }
  }

  const sanitizedText = xss(text, options)

  if (!store.state.presentation.showHyperLink || !isAllowedUnformattingTags) {
    return sanitizedText
  }

  return anchorme(sanitizedText, {
    attributes: [
      {
        name: 'target',
        value: 'blank',
      },
      {
        name: 'class',
        value: 'text-hyper-link',
      },
    ],
  })
})

Vue.filter('dateTimeAgo', (value) => {
  const valueTime = moment(new Date(value), 'YYYYMMDD HH:mm:ss')
  const differenceInSeconds = moment().diff(valueTime, 'seconds')
  // 7 days = 604800 seconds
  if (differenceInSeconds > 604800) {
    return valueTime.format('DD MMM YYYY')
  }
  return moment(new Date(value), 'YYYYMMDD').fromNow()
})

Vue.filter('textAvatar', (value) => {
  if (!value) value = ''
  value = value.trim()
  if (value) {
    return value.match(/./ug)[0]
  }
  return ' '
})

Vue.filter('formatTotalPoint', Util.formatNumber)

Vue.filter('abbreviateNumber', Util.abbreviateNumber)

Vue.filter('profanity', (sentence) => {
  if (!sentence) return ''
  return Util.filterProfaneWords(sentence)
})
